let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("8K2aW")]).then(() => parcelRequire('3IEiO'));